module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/5c74b2c74fb87685d69914f6af840bc2.jpg";